import { IntegrationsMarketplaceGridInstalledController } from '../controller/IntegrationsMarketplaceGridInstalledController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IntegrationsMarketplaceGridInstalledWebComponent extends BaseWebComponentElement {
  public controller: IntegrationsMarketplaceGridInstalledController;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationsMarketplaceGridInstalledController,
    });

  }

  disconnectedCallback(): void {
    this.controller.view.unobserveGridResize();
    super.disconnectedCallback();
  }
}
